import "./CategoryCard.css";
import Card from "react-bootstrap/Card";
import { LinkContainer } from "react-router-bootstrap";

export default function CategoryCard(props) {
  // indiviudal category card, showing the category image, name, short description and a button linking to the category's page
  // props:
  //    image (img): the category image
  //    description (string): the category description
  //    title (string): the category name
  return (
    <LinkContainer
      to={`product-list/category/${props.category._id}`}
      style={{ cursor: "pointer" }}
    >
      <Card className="category-card card-hover-zoom ">
        <div className="category-card-image-container">
          <Card.Img
            className="card-image rounded category-card "
            variant="top"
            src={props.category?.image?.url}
          />
        </div>
        <Card.ImgOverlay className="d-flex align-items-center justify-content-center">
          <div className="text-white position-absolute top-0 start-0 mt-3 ms-4">
            <h3 className="fw-semibold ">{props.category?.name || ""}</h3>
          </div>
        </Card.ImgOverlay>
      </Card>
    </LinkContainer>
  );
}
